import { axiosInstance } from '@/lib/axios'
import { HistoricalFileGroupDto } from './types'

type Props = {
  companyId: string
  dateFrom: string
  dateTo: string
  isDriver: boolean
}

export function getHistoricalFiles({ companyId, dateFrom, dateTo, isDriver }: Props) {
  return axiosInstance.get<HistoricalFileGroupDto[]>(
    `/api/${companyId}/fileProcessing/historical`,
    { params: { dateFrom, dateTo, isDriver } },
  )
}
